import { refreshAccessToken } from '@/shared/api/client';
import { useAuthStore } from './store';

// accessToken 은 보안상 메모리에만 둔다. 새로고침 시에는 persist 된 user 가 있으면
// HttpOnly refresh 쿠키로 세션을 1회 복원한다 (Stage 6 P0 — 새로고침 로그아웃 방지).
let attempted = false;
let bootPromise: Promise<void> | null = null;

export function isAuthBootstrapDone(): boolean {
  return attempted;
}

export function bootstrapAuth(): Promise<void> {
  if (!bootPromise) {
    bootPromise = (async () => {
      const { accessToken, user } = useAuthStore.getState();
      if (!accessToken && user) {
        await refreshAccessToken(); // 실패 시 내부에서 logout() — user 도 정리된다
      }
      attempted = true;
    })();
  }
  return bootPromise;
}
